import "./bootstrap";
import Cookies from "js-cookie";
import "./components/search";

import { AdjustZoom } from "./components/adjustZoom";
import { initGlobalListeners } from "./helpers";

document.addEventListener("DOMContentLoaded", () => {
    new AdjustZoom().init();

    // console.log("top 1: ", getHeaderTop());

    setTimeout(function () {
        if (window.scrollY < 20)
            document.querySelector(".fixed-mobile-menu-wrapper").style.top =
                getHeaderTop() + "px"; // height + vert padding

        window.addEventListener("scroll", () => {
            const scrollY = window.scrollY || window.pageYOffset;

            if (scrollY <= 20) {
                document.querySelector(".fixed-mobile-menu-wrapper").style.top =
                    getHeaderTop() + "px";
            } else {
                document.querySelector(".fixed-mobile-menu-wrapper").style.top =
                    "0px";
            }
        });

        const cookieAccept = document.querySelector("#cookie.open button");
        if (cookieAccept) {
            cookieAccept.addEventListener("click", function (e) {
                document.querySelector(".fixed-mobile-menu-wrapper").style.top =
                    getHeaderTop(false) + "px";
            });
        }
    }, 300);

    document
        .querySelector("#mobileMenu nav")
        .addEventListener("click", function (e) {
            document.getElementById("hamburger").classList.remove("open");
            document.getElementById("mobileMenu").classList.remove("open");
        });
});
$(function () {
    initGlobalListeners();

    // const thequerystring = getUrlVars();
    // if (thequerystring["page"] !== undefined) {
    //     $("html, body").animate(
    //         {
    //             scrollTop: $("#all-sites").offset().top,
    //         },
    //         300
    //     );
    // }
});

document.getElementById("hamburger").addEventListener("click", function () {
    document.getElementById("hamburger").classList.toggle("open");
    document.getElementById("mobileMenu").classList.toggle("open");
});

if (!Cookies.get("visited")) {
    document.getElementById("cookie").classList.add("open");
}

document.querySelector("#cookie button").addEventListener("click", function () {
    document.getElementById("cookie").classList.remove("open");
    Cookies.set("visited", "true");
});

function getHeaderTop(withCookies = true) {
    const heroBanner = document.querySelector(".hero-header");
    const heroBannerRect = heroBanner.getBoundingClientRect();
    let navTop = heroBannerRect.height;

    const isMobile = window.matchMedia("(max-width: 768px)");

    if (withCookies && isMobile.matches) {
        const cookieBanner = document.querySelector("#cookie.open");
        if (cookieBanner) {
            const computed = window.getComputedStyle(cookieBanner);
            navTop += parseFloat(computed.height);
        }
    }
    return navTop;
}

// function getUrlVars() {
//     var vars = [],
//         hash;
//     var hashes = window.location.href
//         .slice(window.location.href.indexOf("?") + 1)
//         .split("&");
//     for (var i = 0; i < hashes.length; i++) {
//         hash = hashes[i].split("=");
//         vars.push(hash[0]);
//         vars[hash[0]] = hash[1];
//     }
//     return vars;
// }
